import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-check': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160h-424c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-260c0-6.6 5.4-12 12-12zM345.3 287.9l-28.2-28.4c-4.7-4.7-12.3-4.7-17-0.1l-106 105.2-46-46.4c-4.7-4.7-12.3-4.7-17-0.1l-28.4 28.2c-4.7 4.7-4.7 12.3-0.1 17l82.6 83.3c4.7 4.7 12.3 4.7 17 0.1l143-141.8c4.7-4.7 4.7-12.3 0.1-17z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-check.js
// module id = 1135
// module chunks = 0